import ng from 'angular';

import { InformationNodeObject } from '@/atomic-components';
import { PaymentMethodOption } from "@/atomic-components";
import './payment-options.scss';

export type PaymentMethod = 'postpaid' | 'card' | 'paypal' | 'others' | 'prepaid';

export class TemplateAccountActivationPaymentOptionsController {
    public static $inject: string[] = [
        '$translate',
    ];

    public paymentLogos = [
        {
            url: '/assets/images/logos/payment-method-bancontact.svg',
            alt: 'Payment Logo Bancontact',
            class: 'w-[33%] border-[1px] rounded-sm border-[#d8d8d8]',
        },
        {
            url: '/assets/images/logos/payment-method-ideal.svg',
            alt: 'Payment Logo iDEAL',
            class: 'w-[33%] border-[1px] rounded-sm border-[#d8d8d8]',
        },
        {
            url: '/assets/images/logos/payment-method-amazon.svg',
            alt: 'Payment Logo Amazon',
            class: 'w-[33%] border-[1px] rounded-sm border-[#d8d8d8] pt-2 pb-1',
        },
    ]

    public paymentMethod: PaymentMethod;
    public paymentMethods: PaymentMethodOption[] = [];
    public sepaData = {
        accountHolder: '',
        iban: '',
        bic: '',
    }

    public showPrepaid = false;
    public sepaFormIsValid = false;
    public prepaidAccepted = false;

    public paymentNoticeForGovernmentInstitutions: InformationNodeObject;

    constructor(
        private $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit = () => {
        this.paymentNoticeForGovernmentInstitutions = {
            headline: this.$translate.instant('TR_030321-523a0f_TR'),
            text: [this.$translate.instant('TR_030321-5f427b_TR')]
        };
        this._fillPaymentMethods();
    }

    private _fillPaymentMethods = () => {
        this.paymentMethods.push({type: 'postpaid', label: this.$translate.instant('TR_090119-e5076a_TR')});
        this.paymentMethods.push({type: 'card', label: this.$translate.instant('TR_090119-aa221e_TR')});
        this.paymentMethods.push({type: 'paypal', label: this.$translate.instant('TR_090119-efbad6_TR')});
        this.paymentMethods.push({type: 'others', label: this.$translate.instant('TR_130625-a7f504_TR')});
        this.paymentMethods.push({type: 'prepaid', label: this.$translate.instant('TR_020725-db805f_TR')});
        this.paymentMethod = 'postpaid';
    }

    public get paymentPanelTitle(): string {
        return this.$translate.instant('TR_080119-5c34c3_TR');
    }

    public get selectedPaymentMethod() {
        return this.paymentMethod;
    }

    public linkClicked() {
        this.showPrepaid = true;
    }
}

export class TemplateAccountActivationPaymentOptionsComponent implements ng.IComponentOptions {
    public bindings = {
        paymentMethod: '=',
        token: '<',
        sepaData: '=',
        sepaFormIsValid: '=',
        prepaidAccepted: '=',
    };
    public template = require('./payment-options.html');
    public controller = TemplateAccountActivationPaymentOptionsController;
}
